import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  object: object;
  include?: string[] | null;
  expanded?: boolean;
  appearance?: 'regular' | 'json';
}


import { ref, watch, Ref } from 'vue';
import startCase from 'lodash/startCase';

import { dateFilter } from '@filters/date';

import Icon from '@components/Icon.vue';

import { faCaretRight } from '@icons/solid/faCaretRight';
import { faCaretDown } from '@icons/solid/faCaretDown';

declare module 'vue/types/vue' {
  export interface Vue {
    DisplayObject: ComponentWithProps<Props>;
  }
}

interface PropertyBaseInfo {
  key: string;
  label: string;
  blank: boolean;
  value: unknown;
  expanded: boolean;
}

interface GeneralPropertyInfo extends PropertyBaseInfo {
  type:
    | 'string'
    | 'number'
    | 'boolean'
    | 'bigint'
    | 'symbol'
    | 'date'
    | 'null'
    | 'undefined';
  value: unknown;
}

interface ObjectPropertyInfo extends PropertyBaseInfo {
  type: 'object';
  value: object;
}

type PropertyInfo = GeneralPropertyInfo | ObjectPropertyInfo;

const __default__ = { name: 'DisplayObject' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    object: null,
    include: { default: null },
    expanded: { type: Boolean, default: false },
    appearance: { default: 'regular' }
  },
  setup(__props: any) {

const props = __props as { object: object, include: string[] | null, expanded: boolean, appearance: 'regular' | 'json' };

/**
 * `DisplayObject` component properties.
 */


const properties: Ref<PropertyInfo[]> = ref([]);

watch(
  [() => props.object, () => props.include],
  ([obj, include]) => {
    let entries = Object.entries(obj);

    if (include) {
      entries = entries.filter(([key]) => include.includes(key));
    }

    properties.value = entries.map(mapObjectProperty);
  },
  { immediate: true },
);

function onClick(prop: PropertyInfo) {
  if (prop.type === 'object') {
    prop.expanded = !prop.expanded;
  }
}

function mapObjectProperty(entry: [string, unknown]) {
  let [key, value] = entry;

  const label = props.appearance === 'json' ? key : startCase(key);

  const blank = value === null || value === undefined || value === '';

  let type: string;

  if (value === null) {
    type = 'null';
  } else if (value === undefined) {
    type = 'undefined';
  } else if (value instanceof Date) {
    type = 'date';
  } else {
    type = typeof value;
  }

  if (value instanceof Date) {
    value = dateFilter(value, 'MM/dd/yyyy');
  }

  const prop = {
    key,
    label,
    blank,
    value,
    type,
    expanded: props.expanded,
  };

  return prop as PropertyInfo;
}

return { __sfc: true,props, properties, onClick, mapObjectProperty, Icon, faCaretRight, faCaretDown }
}

})